import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["price", "checkoutButton", "stickyTotalsArea"];

    connect() {
        this.toggleCheckoutButton();
        this.updatePriceWidget();
        this.publishSalonLogoEvent();
    }

    get paymentAmount() {
        return parseFloat(this.data.get("payment-amount"));
    }

    set paymentAmount(value) {
        this.data.set("payment-amount", value.toString());
        this.toggleCheckoutButton();
        this.updatePriceWidget();
    }

    get voucherValue() {
        return parseFloat(this.data.get("voucher-value"));
    }

    set voucherValue(value) {
        this.data.set("voucher-value", value.toString());
    }

    get recipientEmail() {
        return this.data.get("recipient-email");
    }

    set recipientEmail(value) {
        this.data.set("recipient-email", value);
        this.toggleCheckoutButton();
    }

    get recipientMessage() {
        return this.data.get("recipient-message");
    }

    set recipientMessage(value) {
        this.data.set("recipient-message", value);
    }

    get purchaserFirstName() {
        return this.data.get("purchaser-first-name");
    }

    set purchaserFirstName(value) {
        this.data.set("purchaser-first-name", value);
        this.toggleCheckoutButton();
    }

    get purchaserLastName() {
        return this.data.get("purchaser-last-name");
    }

    set purchaserLastName(value) {
        this.data.set("purchaser-last-name", value);
        this.toggleCheckoutButton();
    }

    get sendOption() {
        return this.data.get("send-option");
    }

    set sendOption(value) {
        this.data.set("send-option", value);
        this.toggleCheckoutButton();
    }

    get isMessageInError() {
        return this.data.get("is-message-in-error") == "true";
    }

    set isMessageInError(value) {
        this.data.set("is-message-in-error", value);
        this.toggleCheckoutButton();
    }

    get purchaserEmail() {
        return this.data.get("purchaser-email");
    }

    set purchaserEmail(value) {
        this.data.set("purchaser-email", value);
        this.toggleCheckoutButton();
    }

    updatePaymentAmount(event) {
        this.paymentAmount = event.paymentAmount;
    }

    updateVoucherValue(event) {
        this.voucherValue = event.voucherValue;
    }

    updatePurchaserEmail(event) {
        this.purchaserEmail = event.purchaserEmail;
    }

    updateRecipientEmail(event) {
        this.recipientEmail = event.recipientEmail;
    }

    updatePurchaserFirstName(event) {
        this.purchaserFirstName = event.name;
    }

    updatePurchaserLastName(event) {
        this.purchaserLastName = event.name;
    }

    updateRecipientMessage(event) {
        this.recipientMessage = event.recipientMessage;
        this.isMessageInError = event.isInError;
    }

    updateSendOption(event) {
        this.sendOption = event.sendOption;
    }

    checkoutAction() {
        this.publishCheckoutEvent();
    }

    updatePriceWidget() {
        this.priceTargets.forEach(p => p.innerHTML = this.data.get("amountSpanTemplate").replace('AMOUNT', this.paymentAmount.toFixed(2)));
        let hugeNumber = this.paymentAmount.toString().length > 8;
        this.priceTargets.forEach(p => p.classList.toggle('text-3xl', !hugeNumber));
    }

    toggleCheckoutButton() {
        let hasEmail = this.purchaserEmail !== "";
        let hasAmount = this.paymentAmount !== 0;  
        let hasValidAmount = this.paymentAmount >= this.data.get('min-spend-amount') && this.paymentAmount <= this.data.get('max-spend-amount');
        let hasRecipientEmail = this.recipientEmail !== "" ;
        let hasPurchaserName = this.purchaserFirstName !== "" && this.purchaserLastName !== "";
        let checkoutEnabled = false;
        if (this.sendOption == 'SEND_TO_OTHER'){
            checkoutEnabled = hasAmount && hasEmail && hasRecipientEmail && hasPurchaserName && !this.isMessageInError && hasValidAmount;
        } else {
            checkoutEnabled = hasAmount && hasEmail && hasPurchaserName && hasValidAmount;
        }
        this.toggleCheckoutButtonTo(checkoutEnabled);
    }

    toggleCheckoutButtonTo(checkoutEnabled) {
        this.checkoutButtonTargets.forEach(b => b.classList.toggle('btn-disabled', !checkoutEnabled));
        this.checkoutButtonTargets.forEach(b => b.classList.toggle('shadow-brand-md', checkoutEnabled));
        this.checkoutButtonTargets.forEach(b => b.dataset['action'] = (checkoutEnabled ? 'checkout#checkoutAction' : ''));
        this.stickyTotalsAreaTarget.classList.toggle('hidden', !checkoutEnabled);
        this.toggleFooterPadding(checkoutEnabled);
    }

    publishCheckoutEvent() {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("voucher-checked-out", true, true, null);
        this.element.dispatchEvent(event);
        this.toggleFooterPadding(false);
    }

    toggleFooterPadding(showPadding) {
        document.getElementById("footer").classList.toggle("pb-32", showPadding);
    }

    publishSalonLogoEvent() {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("salon-logo-updated", true, true, null);
        this.element.dispatchEvent(event);
    }
}
